import { render } from "./ScratchCardsPage.vue?vue&type=template&id=0592431e&scoped=true"
import script from "./ScratchCardsPage.vue?vue&type=script&lang=js"
export * from "./ScratchCardsPage.vue?vue&type=script&lang=js"

import "./ScratchCardsPage.vue?vue&type=style&index=0&id=0592431e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0592431e"]])

export default __exports__